export default "/img_dots.7b8a5874-ffc6a0.png";